import { ReviewerCardProps } from "@/interfaces";
import TypoGraphy from "@/typography";
import './index.scss';
const ReviewerDetails = ({
  name,
  designation,
  reviewerImage,
  companyName
}: ReviewerCardProps) => {
  return <>
        <div className="reviewer_wrapper">
            <div className="reviewer_image_wrapper">
                <img className="reviewer_image" src={reviewerImage} alt="reviewer" loading='lazy'></img>
            </div>
            <div className="reviewer_content">
                <div style={{
          display: 'flex',
          gap: '4px'
        }}>
                    <TypoGraphy text={name} variant='Desktop/Body 2/M | 14 |120' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx"></TypoGraphy>{tick}
                </div>
                <TypoGraphy text={`${designation} @ ${companyName}`} variant='Desktop/Body 2/R | 14 |120' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx"></TypoGraphy>
            </div>
        </div>
    </>;
};
const tick = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16.502 8.99609C16.502 7.94975 15.858 7.04244 14.8995 6.55219C15.2361 5.53512 15.0459 4.43024 14.3068 3.69122C13.5678 2.95219 12.4629 2.76195 11.4459 3.09853C10.9629 2.14 10.0483 1.49609 9.00195 1.49609C7.95561 1.49609 7.04829 2.14 6.56537 3.09853C5.54098 2.76195 4.4361 2.95219 3.69707 3.69122C2.95805 4.43024 2.77512 5.53512 3.11171 6.55219C2.15317 7.04244 1.50195 7.94975 1.50195 8.99609C1.50195 10.0424 2.15317 10.9498 3.11171 11.44C2.77512 12.4571 2.95805 13.5619 3.69707 14.301C4.4361 15.04 5.54098 15.2229 6.55805 14.8937C7.04829 15.8522 7.95561 16.4961 9.00195 16.4961C10.0483 16.4961 10.9629 15.8522 11.4459 14.8937C12.4629 15.2229 13.5678 15.04 14.3068 14.301C15.0459 13.5619 15.2361 12.4571 14.8995 11.44C15.858 10.9498 16.502 10.0424 16.502 8.99609Z" fill="#37ED81" stroke="#37ED81" strokeWidth="0.875" strokeMiterlimit="10" strokeLinejoin="round" />
  <path d="M6.00195 9.75L8.25195 12L12.002 6.75" stroke="#030A21" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
</svg>;
export default ReviewerDetails;